import type { MessengerWelcomeViewSettings } from '@widgets/messenger/types'
import { useWidgetChannels } from '@widgets/messenger/compositions/useWidgetChannels'
import { useWidgetStore } from '@widgets/messenger/stores/useWidgetStore'
import { computed } from '@/composition/vue/compositionApi'

export const useWidgetWelcomeViewSettings = () => {
  const { widgetSettings } = useWidgetStore()
  const { activeSortedChannels } = useWidgetChannels()

  return computed<MessengerWelcomeViewSettings>(() => {
    return {
      greeting: widgetSettings.value.appearance.welcomeScreen.greeting,
      intro: widgetSettings.value.appearance.welcomeScreen.intro,
      channels: activeSortedChannels.value,
      logoUrl: widgetSettings.value.logoUrl,
    } satisfies MessengerWelcomeViewSettings
  })
}
